import SunCalc from 'suncalc'

export const isDay = () => {
  const position = { lat: 52.0688104, long: 19.4622349 }
  const date = new Date()
  const times = SunCalc.getTimes(date, position.lat, position.long)

  return date >= times.sunrise && date <= times.sunset
}